import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/license/featureGroup/license.featureGroup.upsert.mutation.gql"
import type {
  FeatureGroupUpsertMutation,
  FeatureGroupUpsertMutationVariables,
} from "@/v2-backoffice-client/license/featureGroup/__types__/license.featureGroup.upsert.mutation"

type Options = MutationHookOptions<
  FeatureGroupUpsertMutation,
  FeatureGroupUpsertMutationVariables
>

export function useFeatureGroupUpsertMutation(options?: Options) {
  return useMutation<
    FeatureGroupUpsertMutation,
    FeatureGroupUpsertMutationVariables
  >(mutation, options)
}
